import { render, staticRenderFns } from "./PriceRange.vue?vue&type=template&id=4f0a8f6f&scoped=true&"
import script from "./PriceRange.vue?vue&type=script&lang=js&"
export * from "./PriceRange.vue?vue&type=script&lang=js&"
import style0 from "./PriceRange.vue?vue&type=style&index=0&id=4f0a8f6f&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f0a8f6f",
  null
  
)

export default component.exports